import { render } from "./CollapsibleCard.vue?vue&type=template&id=6fcaee0b&scoped=true&ts=true"
import script from "./CollapsibleCard.vue?vue&type=script&lang=ts"
export * from "./CollapsibleCard.vue?vue&type=script&lang=ts"

import "./CollapsibleCard.vue?vue&type=style&index=0&id=6fcaee0b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcaee0b"]])

export default __exports__